export { default } from './lockedOverlay';
